import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { store } from './_store/store'
import AlertModal from './components/alertModal'
import { Loader } from './components/loader'
import NavigateSetter from './components/navigateSetter'
import ToastAlert from './components/toastAlert'
import PricingPage from './pages/admin/pricingPage'
import ThemeRoutes from './routes'
import { ThemeCustomization } from './themes'
import i18n from './_helpers/i18n' // Import your i18n instance
import { I18nextProvider } from 'react-i18next'

function App() {
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <ThemeCustomization>
          <BrowserRouter>
            <NavigateSetter />
            <AlertModal />
            <ToastAlert />
            <Loader />
            <PricingPage />
            <ThemeRoutes />
          </BrowserRouter>
        </ThemeCustomization>
      </I18nextProvider>
    </Provider>
  )
}

export default App
